import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { CategoryItem } from '../../models/category-item.model';
import { LookupService } from '../../services/lookup.service';

@Component({
    selector: 'categories-selector',
    templateUrl: 'categories-selector.component.html',
    styleUrls: ['categories-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CategoriesSelectorComponent {
    @Input() parentFormGroup: FormGroup;
    @Input() controlName: string;
    @Input() placeholderText: string;

    readonly categories$: Observable<CategoryItem[]>;

    constructor(lookupService: LookupService) {
        this.categories$ = lookupService.getCategories();
    }
}
